module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', {
    staticClass: "app-body"
  }, [_c('h2', [_vm._v("Charts")]), _vm._v(" "), (_vm.charts.length > 0) ? _c('ul', {
    staticClass: "charts-list"
  }, _vm._l((_vm.charts), function(item) {
    return _c('li', {
      staticClass: "charts-entry song"
    }, [_c('div', {
      staticClass: "song__info"
    }, [_c('span', {
      staticClass: "song__title"
    }, [_vm._v(_vm._s(item.song.title))]), _vm._v(" "), _c('span', {
      staticClass: "song__artist"
    }, [_vm._v(_vm._s(item.song.artist))]), _vm._v(" "), _c('span', {
      staticClass: "song__suggestor"
    }, [_vm._v("vorgeschlagen von " + _vm._s(item.suggestor))])]), _vm._v(" "), _c('button', {
      staticClass: "song__action-btn",
      class: (item.has_user_vote) ? 'active' : '',
      on: {
        "click": function($event) {
          _vm.vote(item.id)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-volume-up"
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.votes))])])])
  })) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-31a0b340"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Charts.vue
// module id = 213
// module chunks = 1